<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="类型" prop="type" >-->
<!--        <a-select v-model="form.type" placeholder="请选择类型" >-->
<!--          <a-select-option :key="0">周会员</a-select-option>-->
<!--          <a-select-option :key="1">月会员</a-select-option>-->
<!--          <a-select-option :key="2">年会员</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('vip.menu.unitPrice')" prop="unitPrice" >
        <a-input-number :min="0" :step="0.01" :precision="2" v-model="form.unitPrice" :placeholder="$t('vip.menu.inputUnitPrice')" style="width: 100%" />
      </a-form-model-item>
<!--      <a-form-model-item label="ios内购产品id" prop="productId" >-->
<!--        <a-input v-model="form.productId" placeholder="请输入ios内购产品id" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('vip.menu.remark')" prop="remark" >
        <a-input v-model="form.remarkIn" :placeholder="$t('vip.menu.inputRemark')" />
      </a-form-model-item>


      <a-form-model-item :label="$t('vip.menu.remarkEn')" prop="remark" >
        <a-input v-model="form.remarkEn" :placeholder="$t('vip.menu.inputRemarkEn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('vip.menu.remarkCn')" prop="remark" >
        <a-input v-model="form.remarkCn" :placeholder="$t('vip.menu.inputRemarkCn')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('vip.menu.remarkArabic')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$t('vip.menu.inputRemarkArabic')" />
      </a-form-model-item>
<!--      <a-form-model-item label="总价" prop="totalPrice" >-->
<!--        <a-input v-model="form.totalPrice" placeholder="请输入总价" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMenu, addMenu, updateMenu } from '@/api/vip/menu'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    TagSelectOption
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: null,

        unitPrice: null,

        productId: null,

        totalPrice: null,

        createTime: null,

        remark: null,
        remarkEn: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        type: [
          { required: true, message: this.$t('vip.menu.typeRequired'), trigger: 'change' }
        ],
        unitPrice: [
          { required: true, message: this.$t('vip.menu.unitPriceRequired') }
        ],
        totalPrice: [
          { required: true, message: this.$t('vip.menu.totalPriceRequired') }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        unitPrice: null,
        productId: null,
        totalPrice: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMenu({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMenu(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMenu(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
